import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { setCurrentPageAtomProps } from "../../recoilatoms/Admin";

const columns = [
  {
    title: "No",
    dataIndex: "No",
  },
  {
    title: "Title",
    dataIndex: "Title",
  },
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Channel",
    dataIndex: "ServiceSortation",
  },
  {
    title: "담당자",
    dataIndex: "EmpNm",
  },
  {
    title: "Date",
    dataIndex: "Date",
  },
  {
    title: "Status",
    dataIndex: "Status",
  },
  {
    title: "Elapsed",
    dataIndex: "Elapsed",
    render: (elapsed) => {
      if (elapsed === "Elapsed1") return <Elapsed />;
      else if (elapsed === "Elapsed2") return <Elapsed2 />;
      else if (elapsed === "Elapsed3") return <Elapsed3 />;
      else return null;
    },
  },
];

const TableList = (props) => {
  // console.log("props", props);
  const { filterboard } = props;
  const [filterData, setFilterData] = useState([]);
  const [elapsedTime, setElapsedTime] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setFilterData();
  }, []);

  useEffect(() => {
    const today = new Date();
    const nowTime = today.getTime();
    setElapsedTime(nowTime);
  }, []);

  useEffect(() => {
    setFilterData(() => {
      return filterboard.map((element, id) => {
        // console.log("게시판 리스트", element);
        if (element.accept === "0") {
          element.accept = "대기";
        } else if (element.accept === "1") {
          element.accept = "접수";
        } else if (element.accept === "2") {
          element.accept = "보류";
        } else if (element.accept === "3") {
          element.accept = "삭제";
        } else if (element.accept === "5") {
          element.accept = "종료";
        }

        if (
          Math.floor(elapsedTime / 1000) - Math.floor(Number(element.oriDateTime) / 1000) <= 10800 &&
          (element.accept === "대기" || element.accept === "접수" || element.accept === "보류")
        ) {
          element.oriDateTime = "Elapsed1";
        } else if (
          Math.floor(elapsedTime / 1000) - Math.floor(Number(element.oriDateTime) / 1000) > 10800 &&
          Math.floor(elapsedTime / 1000) - Math.floor(Number(element.oriDateTime) / 1000) < 21600 &&
          (element.accept === "대기" || element.accept === "접수" || element.accept === "보류")
        ) {
          element.oriDateTime = "Elapsed2";
        } else if (
          Math.floor(elapsedTime / 1000) - Math.floor(Number(element.oriDateTime) / 1000) > 21600 &&
          (element.accept === "대기" || element.accept === "접수" || element.accept === "보류")
        ) {
          element.oriDateTime = "Elapsed3";
        } else {
          element.oriDateTime = null;
        }

        if (element.serviceSortation === "01") {
          element.serviceSortation = "인트라넷";
        } else if (element.serviceSortation === "02") {
          element.serviceSortation = "싸다오";
        } else if (element.serviceSortation === "03") {
          element.serviceSortation = "아레오";
        } else if (element.serviceSortation === "04") {
          element.serviceSortation = "네띠앙";
        } else if (element.serviceSortation === "05") {
          element.serviceSortation = "서울이동통신";
        } else if (element.serviceSortation === "06") {
          element.serviceSortation = "스탠다드 네트웍스";
        } else if (element.serviceSortation === "07") {
          element.serviceSortation = "업체문의";
        } else if (element.serviceSortation === "08") {
          element.serviceSortation = "고객사";
        } else if (element.serviceSortation === "09") {
          element.serviceSortation = "UMS";
        } else if (element.serviceSortation === "10") {
          element.serviceSortation = "영업부 요청사항";
        } else if (element.serviceSortation === "11") {
          element.serviceSortation = "Say015&SMART015";
        } else if (element.serviceSortation === "null") {
          element.serviceSortation = "미분류";
        }

        return {
          key: id,
          No: element.no,
          Title: element.title,
          Name: element.name,
          Date: element.dateTime,
          Status: element.accept,
          Elapsed: element.oriDateTime,
          Content: element.content,
          ServiceSortation: element.serviceSortation,
          Email: element.email,
          FileOriginName: element.fileOriginName,
          EmpId: element.empId,
          EmpNm: element.empNm,
          PhoneNumber: element.phoneNumber,
        };
      });
    });
  }, [filterboard, elapsedTime]);

  const handleRowClick = (record) => {
    navigate(`/AdminVocDetail`, { replace: false, state: record });

    // record: 클릭한 행의 데이터
    // rowIndex: 클릭한 행의 인덱스
    // 상세보기 페이지로 record를 전달하여 렌더링하는 로직을 작성
  };

  return (
    <>
      <Table
        columns={columns}
        dataSource={filterData}
        pagination={{ position: ["none", "none"] }}
        onRow={(record, rowIndex) => {
          // console.log("record", record);
          // console.log("rowIndex", rowIndex);
          return {
            onClick: () => handleRowClick(record, rowIndex),
          };
        }}
      />
    </>
  );
};

export default TableList;
//초록
const Elapsed = styled.div`
  width: 15px;
  height: 15px;
  background: #15ff00;
  border-radius: 50px;
`;
//주황
const Elapsed2 = styled.div`
  width: 15px;
  height: 15px;
  background: #ffc400;
  border-radius: 50px;
`;
//빨강
const Elapsed3 = styled.div`
  width: 15px;
  height: 15px;
  background: #ff0000;
  border-radius: 50px;
`;
